import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import ClientUserAssignment from './client_user_assignment';
import User from './user';

@Model()
export default class LdapLocalAdminChange extends ApplicationRecord {
  static jsonapiType = 'ldap_local_admin_changes';
  @Attr() localAdmin: boolean;
  @BelongsTo() user: User;
  @BelongsTo() clientUserAssignment: ClientUserAssignment;
}
